module.exports = __webpack_public_path__ + "static/media/used-car-transparent.eeea1bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/used-car-transparent.png
// module id = 2734
// module chunks = 0